// BL-177 Step 2d (section 5): "This device" card helpers for Settings > My notifications.
//   deviceDisplayName() -> "Safari on Mac", "Chrome on Windows", "Safari on iPhone" (from the user agent).
//   sendTestPush()      -> asks the push-test-send Edge Function to push to THIS browser's subscription only.

function iosDevice(ua, nav) {
    if (/iPad/.test(ua) || (nav?.platform === 'MacIntel' && nav?.maxTouchPoints > 1)) return 'iPad';
    if (/iPhone|iPod/.test(ua)) return 'iPhone';
    return '';
}

export function deviceDisplayName(ua = (typeof navigator !== 'undefined' ? navigator.userAgent : ''), nav = (typeof navigator !== 'undefined' ? navigator : {})) {
    const text = String(ua || '');
    const browser = /Edg\//.test(text) || /EdgiOS/.test(text) ? 'Edge'
        : /Firefox|FxiOS/.test(text) ? 'Firefox'
            : /OPR\/|OPiOS/.test(text) ? 'Opera'
                : /Chrome|CriOS/.test(text) ? 'Chrome'
                    : /Safari/.test(text) ? 'Safari'
                        : 'This browser';
    const ios = iosDevice(text, nav);
    const os = ios
        || (/Android/.test(text) ? 'Android'
            : /CrOS/.test(text) ? 'Chromebook'
                : /Windows/.test(text) ? 'Windows'
                    : /Macintosh|Mac OS X/.test(text) ? 'Mac'
                        : /Linux/.test(text) ? 'Linux'
                            : '');
    return os ? `${browser} on ${os}` : browser;
}

export const TEST_PUSH_FUNCTION = 'push-test-send';

/**
 * Sends one test push to this browser's own subscription. The Edge Function checks that the endpoint belongs to the
 * signed-in person (enabled row in push_tokens) before sending, so a test can never reach anyone else's device.
 */
export async function sendTestPush(client) {
    if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
        throw new Error('This browser does not support device notifications.');
    }
    const registration = await navigator.serviceWorker.getRegistration();
    const subscription = await registration?.pushManager?.getSubscription();
    if (!subscription?.endpoint) throw new Error('This device is not set up for alerts yet. Turn on the switch first.');
    const { data, error } = await client.functions.invoke(TEST_PUSH_FUNCTION, { body: { endpoint: subscription.endpoint } });
    if (error) {
        let message = error.message || 'The test could not be sent.';
        try {
            const body = await error.context?.json?.();
            if (body?.error) message = body.error;
        } catch (_ignored) { /* keep the transport message */ }
        throw new Error(message);
    }
    if (!data || data.sent !== true) throw new Error(data?.error || 'The test could not be sent.');
    return data;
}
